import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import { useEffect } from "react";

type SearchBarProps = {
  setSearchQuery: (value: string) => void;
  displayMessage: string;
  setDisplayMessage: (value: string) => void;
};

export const SearchBar = ({
  setSearchQuery,
  displayMessage,
  setDisplayMessage,
}: SearchBarProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayMessage(event.target.value);
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => setSearchQuery(displayMessage), 500);
    return () => clearTimeout(timeOutId);
  }, [displayMessage, setSearchQuery]);

  return (
    <TextField
      value={displayMessage}
      id="search-bar"
      className="text"
      onChange={handleChange}
      label="Search"
      variant="outlined"
      placeholder="Search..."
      size="small"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};
